<template>        
        
        <form-helper >
            <div slot="form-header">

                <h4 class="grey--text text--darken-2">Geokoordinaten</h4>                                   

            </div>

            <div slot="form-fields">


            <v-layout row>
                <v-flex xs12>
                    Lat
                </v-flex>
            </v-layout>  
            <v-divider class="my-4"></v-divider>
            <v-layout row>
                <v-flex xs12>
                    Long
                </v-flex>
            </v-layout>    
               
            </div>
            <div slot="form-commands" >

                <v-btn icon v-on:click="submitted">
                    <v-icon x-large class="green--text">done</v-icon>
                </v-btn>                        


                <router-link to="/firmen" exact>
                    <v-btn icon>
                        <v-icon x-large class="red--text">close</v-icon>
                    </v-btn>
                </router-link>

            </div>
            
        </form-helper>
       
</template>

<script>
import formHelper from '../formHelper.vue'


export default {
    components: {
        'form-helper': formHelper,
        
    },
    data() {
        return {
            id: this.$route.params.id,            
        };
    },
    computed: {
        ad: function() {
            return this.$store.getters.adresse
        },
        loading: function() {
            return this.$store.getters.loading
        }
    },
    
    methods: {
        submitted: function() {
                        
            this.$emit('submitted', this.ad)
        },
                
    },
    
    
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// editAdressen_2.vue?4bc376a3